import { Component, OnInit } from '@angular/core';
import {FormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {EmailService} from "../services/email.service";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactComponent implements OnInit {
  contactForm = new UntypedFormGroup({});
  contactErrorMessage: string | undefined;
  contactSuccessMessage: string | undefined;
  formSubmitted = false;

  constructor(private fb: FormBuilder, private mailService: EmailService) { }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phonenumber: [''],
      message: ['', [Validators.required]],
      privacy: [false, [Validators.requiredTrue]]
    });
  }

  async sendContactForm() {
    // Exits out of function if the credential form hasn't been filled in validly.
    if(!this.contactForm.valid) {
      this.formSubmitted = true;
      return;
    }

    let recipient = 'info@steddie.nl';
    let subject = 'Nieuw bericht uit het contactformulier';
    let body = `Naam: ${this.name?.value} <br>Emailadres: ${this.email?.value} <br>Telefoonnummer: ${this.phonenumber?.value} <br>Bericht: ${this.message?.value}`;

    this.mailService.sendEmail(recipient, subject, body).then(
      () => {
        this.contactErrorMessage = undefined;
        this.contactSuccessMessage = 'Uw bericht is succesvol verzonden. We nemen zo snel mogelijk contact met u op!'
        this.contactForm.reset();
      },
      async (err) => {
        this.contactSuccessMessage = undefined;
        this.contactErrorMessage = 'Er is een fout opgetreden. Probeer het later opnieuw';
      }
    );
  }

  /**
   * @return Filled in email value on contact form.
   */
  get email() {
    return this.contactForm.get('email');
  }

  /**
   * @return Filled in name value on contact form.
   */
  get name() {
    return this.contactForm.get('name');
  }

  /**
   * @return Filled in phone number value on contact form.
   */
  get phonenumber() {
    return this.contactForm.get('phonenumber');
  }

  /**
   * @return Filled in message value on contact form.
   */
  get message() {
    return this.contactForm.get('message');
  }

  /**
   * @return Value of privacy checkbox on contact form.
   */
  get privacy() {
    return this.contactForm.get('privacy');
  }
}
